<script lang="ts">
    import {link} from 'svelte-spa-router'
    import Fa from 'svelte-fa'

    import { faLine } from '@fortawesome/free-brands-svg-icons';
    import { faUserPlus,faHomeUser,faSignIn } from '@fortawesome/free-solid-svg-icons';

    let dataSetting = JSON.parse(window.localStorage.getItem('setting'))
    let myLink = dataSetting.homepage


</script>
<div class="col-4">
    <a href={myLink} class="btn btn-outline-secondary btn-sm btn-gd" style="--bs-btn-padding-y: .10rem; --bs-btn-padding-x: .3rem; --bs-btn-font-size: .7rem;background: linear-gradient(135deg, rgb(0 0 0) 0%, rgb(86 80 80) 50%, rgb(131 120 120) 51%, rgb(54 50 50) 71%, rgb(0 0 0) 100%);
    box-shadow: 5px 5px 10px #000 !important;"><Fa icon={faHomeUser} /> หน้าหลัก</a>
</div>
<div class="col-5 text-end">
    <!-- <img src="{dataSetting.logo}" class="img-fluid"> -->
</div>
<div class="col-3 text-end" style="position: relative;">
    <img src="{dataSetting.logo_wallet}" alt="" style="max-width: 100%;    position: absolute; left: -10px;top: 0;">
    <!-- <a href="{dataSetting.lineurl}" target="_blank"><span class="badge rounded-pill text-bg-success"><Fa icon={faLine} size="xxl"/> <span style="font-size: .6rem; font-weight:400;">{dataSetting.lineid}</span></span></a> -->
</div>
